import { useEffect, useState } from "react";

import { StyledHomePageFlexBackground } from "./styles";

const HomePageHeaderBackground = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <StyledHomePageFlexBackground>
            <svg
                width={screenWidth}
                height="216"
                viewBox={`0 0 ${screenWidth} 216`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_1159_54028)">
                    <rect
                        width={screenWidth}
                        height="216"
                        fill="url(#paint0_radial_1159_54028)"
                    />
                    <rect
                        width={screenWidth}
                        height="216"
                        fill="url(#paint1_radial_1159_54028)"
                    />
                    <rect
                        width={screenWidth}
                        height="216"
                        fill="url(#paint2_radial_1159_54028)"
                        fillOpacity="0.1"
                    />
                    <rect
                        width={screenWidth}
                        height="219"
                        transform="matrix(1 0 0 -1 0 216)"
                        fill="url(#paint3_radial_1159_54028)"
                    />
                    <rect
                        width={screenWidth}
                        height="219"
                        transform="matrix(1 0 0 -1 0 216)"
                        fill="url(#paint4_radial_1159_54028)"
                        fillOpacity="0.3"
                    />
                    <rect
                        width={screenWidth}
                        height="219"
                        transform="matrix(1 0 0 -1 0 216)"
                        fill="url(#paint5_radial_1159_54028)"
                        fillOpacity="0.1"
                    />
                    <path
                        opacity="0.6"
                        d="M-82.4058 190.381C-103.721 211.696 -103.721 246.255 -82.4059 267.57C-61.0909 288.885 -26.5325 288.885 -5.21759 267.57L155.57 106.782C176.885 85.4675 176.885 50.9091 155.57 29.5941C134.255 8.27919 99.6964 8.27918 78.3815 29.5941L-82.4058 190.381Z"
                        fill="url(#paint6_linear_1159_54028)"
                    />
                    <path
                        opacity="0.6"
                        d="M-76.6525 305.423C-89.547 318.317 -89.547 339.224 -76.6525 352.118C-63.758 365.012 -42.852 365.012 -29.9575 352.118L150.118 172.043C163.012 159.148 163.012 138.242 150.118 125.348C137.223 112.453 116.317 112.453 103.423 125.348L-76.6525 305.423Z"
                        fill="url(#paint7_linear_1159_54028)"
                    />
                    <path
                        opacity="0.5"
                        d="M1457.93 388.474C1436.98 409.422 1436.98 443.385 1457.93 464.333C1478.88 485.281 1512.84 485.281 1533.79 464.333L1826.33 171.789C1847.28 150.841 1847.28 116.878 1826.33 95.9298C1805.38 74.982 1771.42 74.9819 1750.47 95.9298L1457.93 388.474Z"
                        fill="url(#paint8_linear_1159_54028)"
                    />
                    <path
                        opacity="0.6"
                        d="M1284.86 660.528C1217.56 727.827 1217.56 836.942 1284.86 904.242C1352.16 971.542 1461.27 971.542 1528.57 904.242L2036.24 396.572C2103.54 329.272 2103.54 220.157 2036.24 152.857C1968.94 85.5574 1859.83 85.5574 1792.53 152.857L1284.86 660.528Z"
                        fill="url(#paint9_linear_1159_54028)"
                    />
                </g>
                <defs>
                    <radialGradient
                        id="paint0_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(863.493 64.9666) rotate(7.97673) scale(752.252 10216.7)"
                    >
                        <stop stopColor="#ECF1FB" />
                        <stop
                            offset="1"
                            stopColor="#F8F8F8"
                        />
                    </radialGradient>
                    <radialGradient
                        id="paint1_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform={`translate(${screenWidth} 2.16762e-06) rotate(175.477) scale(964.697 192.982)`}
                    >
                        <stop stopColor="#FF8400" />
                        <stop
                            offset="1"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </radialGradient>
                    <radialGradient
                        id="paint2_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(836.402 167.136) rotate(-5.88898) scale(968.71 773.643)"
                    >
                        <stop stopColor="#0073FF" />
                        <stop
                            offset="1"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </radialGradient>
                    <radialGradient
                        id="paint3_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(755.851 1.19712e-05) rotate(11.3866) scale(869.733 12482.3)"
                    >
                        <stop stopColor="#ECF1FB" />
                        <stop
                            offset="1"
                            stopColor="#F8F8F8"
                        />
                    </radialGradient>
                    <radialGradient
                        id="paint4_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform={`translate(${screenWidth}) rotate(175.415) scale(964.781 195.645)`}
                    >
                        <stop stopColor="#FFE352" />
                        <stop
                            offset="1"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </radialGradient>
                    <radialGradient
                        id="paint5_radial_1159_54028"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(836.402 169.458) rotate(-5.97018) scale(968.853 784.272)"
                    >
                        <stop stopColor="#0073FF" />
                        <stop
                            offset="1"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </radialGradient>
                    <linearGradient
                        id="paint6_linear_1159_54028"
                        x1="147.113"
                        y1="40.7306"
                        x2="3.74275"
                        y2="191.429"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="white" />
                        <stop
                            offset="0.808511"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="paint7_linear_1159_54028"
                        x1="141.593"
                        y1="135.493"
                        x2="7.10551"
                        y2="280.97"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="white" />
                        <stop
                            offset="0.808511"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="paint8_linear_1159_54028"
                        x1="1668.66"
                        y1="161.865"
                        x2="1659.56"
                        y2="375.257"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="white" />
                        <stop
                            offset="0.808511"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="paint9_linear_1159_54028"
                        x1="2009.54"
                        y1="188.02"
                        x2="1556.86"
                        y2="663.834"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="white" />
                        <stop
                            offset="0.808511"
                            stopColor="white"
                            stopOpacity="0"
                        />
                    </linearGradient>
                    <clipPath id="clip0_1159_54028">
                        <rect
                            width={screenWidth}
                            height="216"
                            fill="white"
                        />
                    </clipPath>
                </defs>
            </svg>
        </StyledHomePageFlexBackground>
    );
};

export default HomePageHeaderBackground;
